export enum MovimentoFinanceiroEnum {
  SALDO_COM_DESCONTO = 'Saldo com Desconto',
  VALOR_FINAL_PARCELA = 'Valor Final Parcela',
  DISTRIBUIR_CONF_SALDO = 'Digitado, distribuir conf Saldo',
  DISTRIBUIR_CONF_VALOR_FINAL = 'Digitado, distribuir conf Valor Final',
}